import {EventEmitter, Injectable} from '@angular/core';
import {EventTypes} from "../event-types";
import {BehaviorSubject, Subject} from "rxjs";

@Injectable({
  providedIn: 'root'
})
export class SharedService {

  eventEmitter: EventEmitter<{ type: EventTypes; data: any }> = new EventEmitter();

  private companyUpdatedSubject = new BehaviorSubject<any>(null);
  private changeCompanySubject = new Subject<any>();
  private changeCompanyBannerSubject = new BehaviorSubject<{ message: string, showLoading: boolean, showBanner: boolean }>(null);

  // Separate event emitters for different components
  searchPersonEventEmitter: EventEmitter<{ type: EventTypes; data: any }> = new EventEmitter();
  peopleEventEmitter: EventEmitter<{ type: EventTypes; data: any }> = new EventEmitter();

  // Observable for company updates
  companyUpdated$ = this.companyUpdatedSubject.asObservable();
  changeCompany$ = this.changeCompanySubject.asObservable();
  changeCompanyBanner$ = this.changeCompanyBannerSubject.asObservable();

  // Method to emit company updates
  emitCompanyUpdate(company: any): void {
    this.companyUpdatedSubject.next(company);
  }

  emitEvent(type: EventTypes, data: any) {
    this.eventEmitter.emit({ type, data });
  }

  // Updated emit methods for specific components
  emitSearchPersonEvent(type: EventTypes, data: any) {
    this.searchPersonEventEmitter.emit({ type, data });
  }

  emitPeopleEvent(type: EventTypes, data: any) {
    this.peopleEventEmitter.emit({ type, data });
  }

  emitChangeCompany(company: any): void {
    this.changeCompanySubject.next(company);
  }

  emitChangeCompanyBanner(message: string, showLoading: boolean, showBanner: boolean): void {
    this.changeCompanyBannerSubject.next({message, showLoading, showBanner});
  }

}
